import { buildColorPropsSDKFactoryCreator } from './colorPropsSDKFactoryBuilder';
import type { IColorSDK } from './colorPropsSDKFactoryBuilder';

export type IFillColorSDK = IColorSDK<'fillColor'>;

export const createFillColorPropsSDKFactory =
  buildColorPropsSDKFactoryCreator('fillColor');
